const stickyBag = document.querySelector('[data-sticky-bag]');
const addToCartButton = document.querySelector('[data-add-to-cart-button]');

if (stickyBag && addToCartButton) {
  const stickyBagButton = stickyBag.querySelector('[data-sticky-bag-button]');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        stickyBag.hidden = false;
        stickyBag.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { rootMargin: '0px' }
  );
  observer.observe(addToCartButton);

  stickyBagButton.addEventListener('click', () => {
    addToCartButton.click();
  });
}
